import { Col, Row, Nav, Container, NavDropdown } from 'react-bootstrap'
import '../App.css';
import { useSearchParams } from 'react-router-dom'
import React from 'react';
import j1_sat from '../logos/j1_sat.jpg'
import cisessLogo from '../logos/cisess_logo.png'
import starLogo from '../logos/noaa_logo.png'
import jpssLogo from '../logos/jpss_logo.png'

import regions from '../JSON/regions.json'

const MyNavbar = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const handleParams = (eventKey) => {
        if (eventKey) {
            setSearchParams({ page: eventKey })
        }
    }

    const getTopText = () => {
        const page = searchParams.get('page');

        if(page === 'Home'){
            return "NOAA NESDIS Liquid Equivalent Snowfall Rate";
        } else if(page === 'Animations'){
            return "Animations";
        } else if(page === 'Publication'){
            return "Publication";
        } else if(page === 'Team'){
            return "Team";
        }else if(page === 'AnimationGenerator'){
            return "Animation Generator";
        }

        for(const regionKey in regions){
            if(regions[regionKey]["full_name"] === page){
                if(regions[regionKey]["merged"]){
                    return "Radar-Satellite Merged Liquid Equivalent Snowfall Rate ";
                } else {
                    return "NOAA NESDIS Liquid Equivalent Snowfall Rate";
                }
            }
        }


        return "NOAA NESDIS Liquid Equivalent Snowfall Rate"; 
        // switch (searchParams.get('page')) {
        //     case 'Home':
        //         return "NOAA NESDIS Liquid Equivalent Snowfall Rate";
        //     case 'SFR-CONUS':
        //         return "NOAA NESDIS Liquid Equivalent SFR";
        //     case 'SFR-Alaska':
        //         return "NOAA NESDIS Liquid Equivalent SFR";
        //     case 'mSFR-CONUS':
        //         return "Radar-Satellite Merged SFR";
        //     case 'SFR-Europe':
        //         return "NOAA NESDIS Liquid Equivalent SFR";
        //     case 'SFR-SAfrica':
        //         return "NOAA NESDIS Liquid Equivalent SFR";
        //     case 'Animations':
        //         return "Animations"
        //     case 'Publication':
        //         return "Publication";
        //     case 'Team':
        //         return "Team";
        //    case 'GenerateGif':
        //         return "Generate Gif";
        //     default:
        //         return "NOAA NESDIS Liquid Equivalent Snowfall Rate";
        // }
    }

    return (
        // <div style={{ backgroundColor: "darkblue" }}>
        <div style={{ backgroundColor: "#313d7d", minWidth: "1400px" }}>
            <Container fluid >
                <Row className="align-items-center" style={{ flexWrap: "nowrap" }}>
                    <Col xs="auto" style={{ padding: "0px" }}>
                        <img src={j1_sat} alt="J1 Satellite" className='headerImage1' />
                    </Col>
                    <Col>
                        <Row className="nav-text" style={{
                            fontSize: '200%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '120px',
                            fontweight: 'bold'
                        }}>
                            {getTopText()}
                        </Row>
                        <Row>
                            <Nav justify color='white' onSelect={handleParams} activeKey={null}>
                                <Nav.Link eventKey="Home" style={{ fontSize: '140%' }}>Home</Nav.Link>
                                <NavDropdown title="Product" id="basic-nav-dropdown" style={{ fontSize: '140%' }}>

                                {Object.entries(regions)
                                .filter(([key, value]) => value.full_name)
                                .map(([key, value]) => (
                                        <NavDropdown.Item key={key} eventKey={value.full_name}>
                                            {value.full_name}
                                        </NavDropdown.Item>
                                    ))}

                                    <NavDropdown.Item
                                        onClick={() => {
                                            const baseUrl = `${window.location.origin}${window.location.pathname}`;
                                            window.open(
                                                `${baseUrl}?page=AnimationGenerator`,
                                                'AnimationGeneratorWindow',
                                                'width=1200,height=800,scrollbars=yes,resizable=yes,left=50,top=50'
                                            );
                                        }}
                                    >
                                        Animation Generator
                                    </NavDropdown.Item>

                                    <NavDropdown.Item href="http://gpsmet.umd.edu/sfr/sfr_v0" eventKey=""
                                        target="_blank" rel="noreferrer noopener">Previous SFR Page</NavDropdown.Item>
                                </NavDropdown>
                                <NavDropdown title="Document" id="basic-nav-dropdown" style={{ fontSize: '140%' }}>
                                    <NavDropdown.Item href="https://drive.google.com/file/d/1v_oqSilIN9nXtk3bzc-MmLHayN-4xHiX/view?usp=sharing" eventKey=""
                                        target="_blank" rel="noreferrer noopener">SFR Quick Guide</NavDropdown.Item>
                                    <NavDropdown.Item href="https://drive.google.com/file/d/1J3iZ38x9HFGf3ZaDX8ZN_X5hxRR8xQrx/view?usp=sharing" eventKey=""
                                        target="_blank" rel="noreferrer noopener">mSFR Quick Guide</NavDropdown.Item>
                                    <NavDropdown.Item href="https://drive.google.com/file/d/17yw9iqE9W2CfPsnQCufK5I7UFzhy9m8Q/view?usp=sharing" eventKey=""
                                        target="_blank" rel="noreferrer noopener">ATBD</NavDropdown.Item>
                                    <NavDropdown.Item eventKey="Animations">Animations</NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link eventKey="Publication" style={{ fontSize: '140%' }}>Publication</Nav.Link>
                                <NavDropdown title="About" id="basic-nav-dropdown" style={{ fontSize: '140%' }}>
                                    <NavDropdown.Item eventKey="Team">Team</NavDropdown.Item>
                                    <NavDropdown.Item href="https://www.star.nesdis.noaa.gov/star/index.php" eventKey=""
                                        target="_blank" rel="noreferrer noopener">NESDIS STAR</NavDropdown.Item>
                                    <NavDropdown.Item href="https://cisess.umd.edu" eventKey=""
                                        target="_blank" rel="noreferrer noopener">CISESS</NavDropdown.Item>
                                    <NavDropdown.Item href="https://ipwg-snowfall-fg.umd.edu" eventKey=""
                                        target="_blank" rel="noreferrer noopener">IPWG-SNOWFALL-FG</NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Row>
                    </Col >
                    <Col xs="auto" style={{ padding: "0px" }}>
                        <a href="https://www.star.nesdis.noaa.gov/star/index.php" target="_blank" rel="noreferrer noopener">
                            <img src={starLogo} alt="STAR logo" className="headerImage" />
                        </a>
                    </Col>
                    <Col xs="auto" style={{ padding: "0px" }}>
                        <a href="https://cisess.umd.edu" target="_blank" rel="noreferrer noopener">
                            <img src={cisessLogo} alt="CISESS logo" className="headerImage" />
                        </a>
                    </Col>
                    <Col xs="auto" style={{ padding: "0px" }}>
                        <a href="https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/joint-polar-satellite-system" target="_blank" rel="noreferrer noopener">
                            <img src={jpssLogo} alt="JPSS logo" className="headerImage" />
                        </a>
                    </Col>
                </Row>
            </Container>
        </div >
    );
}

export default MyNavbar;



